if (!customElements.get('localization-form')) {
    customElements.define(
        'localization-form',
        class LocalizationForm extends HTMLElement {
            constructor() {
                super();
                this.elements = {
                    input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
                    button: this.querySelector('button'),
                    panel: this.querySelector('.disclosure__list-wrapper'),
                };
                this.elements.button.addEventListener('click', this.openSelector.bind(this));
                this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
                this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

                this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
            }

            hidePanel() {
                this.elements.button.setAttribute('aria-expanded', 'false');
                this.elements.panel.setAttribute('hidden', true);
            }

            onContainerKeyUp(event) {
                if (event.code.toUpperCase() !== 'ESCAPE') return;

                if(this.elements.button.getAttribute('aria-expanded') == 'false') return;
                this.hidePanel();
                event.stopPropagation();
                this.elements.button.focus();
            }

            onItemClick(event) {
                event.preventDefault();
                const form = this.querySelector('form');
                this.elements.input.value = event.currentTarget.dataset.value;
                if (form) form.submit();
            }

            openSelector() {
                this.elements.button.focus();
                this.elements.panel.toggleAttribute('hidden');
                this.elements.button.setAttribute(
                'aria-expanded',
                (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
                );
            }

            closeSelector(event) {
                const isChild =
                  this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
                if (!event.relatedTarget || !isChild) {
                  this.hidePanel();
                }
            }
        }
    );
}

if (!customElements.get('goa-lang-localization-form')) {
    customElements.define(
        'goa-lang-localization-form',
        class LocalizationgoaLanForm extends HTMLElement {
            constructor() {
                super();
                this.elements = {
                    input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
                    button: this.querySelector('button'),
                    panel: this.querySelector('.disclosure__list-wrapper'),
                    ele: this.querySelector('.disclosure__lan--value'),
                    smb: this.querySelector('.button-submit-language'),
                    closebtn: this.querySelector('.disclosure__lan--close'),
                };
                this.elements.button.addEventListener('click', this.openSelector.bind(this));
                this.elements.ele.addEventListener('click', this.openPopUp.bind(this));
                this.elements.smb.addEventListener('click', this.onSubmitForm.bind(this));
                this.elements.closebtn.addEventListener('click', this.closeSelector.bind(this));
                this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

                this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
            }

            hidePanel() {
                this.elements.button.setAttribute('aria-expanded', 'false');
                this.elements.panel.setAttribute('hidden', true);
            }

            onContainerKeyUp(event) {
                if (event.code.toUpperCase() !== 'ESCAPE') return;

                if(this.elements.button.getAttribute('aria-expanded') == 'false') return;
                this.hidePanel();
                event.stopPropagation();
                this.elements.button.focus();
            }

            openPopUp() {
                this.querySelector('.disclosure__list').classList.toggle('active');
            }

            onItemClick(event) {
                event.preventDefault();
                this.elements.input.value = event.currentTarget.dataset.value;
                this.elements.ele.value = event.currentTarget.dataset.value;

                const url = window.location.origin + '/' + event.currentTarget.dataset.lang;

                this.querySelector('.disclosure__list').classList.remove('active');
                this.querySelectorAll('.disclosure__link').forEach((item) => {item.classList.remove('disclosure__link--active')});

                fetch(url, {method: "get"})
                .then((response) => response.text())
                .then((html) => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');

                    console.log(doc.querySelector('.disclosure__lan--value'));

                    let qu = doc.querySelector('.disclosure__lan--value');
                    document.querySelector('.disclosure__lan--value').innerHTML = qu.innerHTML;
                });
                
                if (event.currentTarget) {
                    event.currentTarget.classList.add('disclosure__link--active');
                }
            }

            onSubmitForm() {
                const form = this.querySelector('form');
                if (form) form.submit();
            }

            openSelector() {
                this.elements.button.focus();
                this.elements.panel.toggleAttribute('hidden');
                this.elements.button.setAttribute(
                'aria-expanded',
                (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
                );
            }

            closeSelector(event) {
                const isChild =
                  this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
                if (!event.relatedTarget || !isChild) {
                  this.hidePanel();
                }
            }
        }
    );
}

